<div class="today-overview" [class.dark]="dark">
  <div class="overview-columns">

    <div class="overview-section">
      <div class="overview-section-header">
        <mat-icon>checklist</mat-icon>
        <span>Today's Tasks</span>
        <span class="overview-count" *ngIf="!tasksLoading && tasks.length">{{ pendingTaskCount }} pending</span>
      </div>

      <div class="overview-loading" *ngIf="tasksLoading">
        <span class="overview-spinner"></span> Loading tasks...
      </div>

      <ul class="overview-list" *ngIf="!tasksLoading">
        <li class="overview-item" *ngFor="let task of tasks" [class.completed]="task.completed">
          <span class="overview-item-number" *ngIf="task.taskNumber">#{{ task.taskNumber }}</span>
          <div class="overview-item-info">
            <span class="overview-item-title">{{ task.name }}</span>
            <span class="overview-item-meta">{{ task.assignedBy }} &middot; {{ task.dueLabel }}</span>
          </div>
        </li>
        <li class="overview-empty" *ngIf="tasks.length === 0">No tasks assigned for today</li>
      </ul>
    </div>

    <div class="overview-section">
      <div class="overview-section-header">
        <mat-icon>event</mat-icon>
        <span>Today's Calendar</span>
        <span class="overview-count" *ngIf="!calendarLoading && calendarEvents.length">{{ calendarEvents.length }}</span>
      </div>

      <div class="overview-loading" *ngIf="calendarLoading">
        <span class="overview-spinner"></span> Loading events...
      </div>

      <ul class="overview-list" *ngIf="!calendarLoading">
        <li class="overview-item" *ngFor="let event of calendarEvents">
          <mat-icon class="overview-item-icon">schedule</mat-icon>
          <div class="overview-item-info">
            <span class="overview-item-title">{{ event.name }}</span>
            <span class="overview-item-meta">{{ event.time }}</span>
          </div>
        </li>
        <li class="overview-empty" *ngIf="calendarEvents.length === 0">No events scheduled today</li>
      </ul>
    </div>

  </div>
</div>
